export default __webpack_public_path__ + "static/border-967e92265ed318e9338fd46ce1510cfa.png";